export default __webpack_public_path__ + "static/media/DNo.7-2.7b8dfbdd.jpg";